'use client'

import Image from 'next/image'
import { getMediaUrl } from '@/utilities/getMediaUrl'

interface AgentCardProps {
  name: string
  photoUrl: string | null
}

export function AgentCard({ name, photoUrl }: AgentCardProps) {
  const src = getMediaUrl(photoUrl)

  return (
    <div className="flex items-center gap-3">
      <div className="relative size-10 shrink-0 overflow-hidden bg-muted">
        {src ? (
          <Image src={src} alt={name} fill className="object-cover" sizes="40px" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-base font-medium text-muted-foreground">
            {name.charAt(0)}
          </div>
        )}
      </div>
      <div>
        <p className="text-body-sm font-light uppercase text-muted-foreground">
          Your appraisal with
        </p>
        <p className="text-body-sm font-normal text-foreground">{name}</p>
      </div>
    </div>
  )
}
